<template>
  <div>
    <vs-prompt
      title="Add tip percentage"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="'Add'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Percentage</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input-number :is-disabled="true" v-model="percentage" />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      percentage: 15,
      prompt: false,
    };
  },
  computed: {
    ...mapGetters({}),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.percentage && this.percentage > 0 && this.percentage < 100;
    },
  },
  methods: {
    show(withStorage) {
      this.percentage = 15;
      this.existingId = null;
      this.prompt = true;
    },
    async accept() {
      const dto = parseInt(this.percentage);
      this.$store.commit("pos/countrySettings/createTipPercent", dto);
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
